module.exports = __webpack_public_path__ + "img/Hospital.777275a6.svg";